"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[257],{

/***/ 14212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Icon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var icomoonClasses = [
    "print",
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "caution",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "content",
    "filter",
    "globe",
    "info",
    "link",
    "theme",
    "thumbs-down-filled",
    "thumbs-down-outlined",
    "thumbs-down",
    "thumbs-up-filled",
    "thumbs-up-outlined",
    "thumbs-up",
    "tip",
    "warning-2",
    "warning",
    "zoom", 
];
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? "default" : _size, _className = param.className, className = _className === void 0 ? "" : _className;
    if (icomoonClasses.includes(name)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "icon ".concat(className, " icomoon size-").concat(size, " icon-").concat(name),
            "aria-hidden": "true"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "icon ".concat(className, " docon size-").concat(size, " docon-").concat(name),
        "aria-hidden": "true"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 60257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// UNUSED EXPORTS: Header

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@azure/msal-react/dist/msal-react.esm.js + 2 modules
var msal_react_esm = __webpack_require__(14471);
// EXTERNAL MODULE: ./auth/config.ts + 97 modules
var config = __webpack_require__(68163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./styles/styles.ts
var styles = __webpack_require__(64014);
// EXTERNAL MODULE: ./utils/i18n.ts + 3 modules
var i18n = __webpack_require__(87161);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js + 1 modules
var useClickAway = __webpack_require__(52463);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./components/avatar-menu.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  /* Avatar */\n  figure {\n    /* width: 36px;\n    height: 36px; */\n    /* width: 32px;\n    height: 32px; */\n    width: 62px;\n    height: 60px;\n    margin: 0;\n\n    img {\n      border-radius: 50%;\n      display: block;\n      height: auto;\n      max-height: 100%;\n      width: 100%;\n      background-color: var(--primary);\n      outline-color: var(--text);\n    }\n  }\n\n  .initials {\n    display: block;\n    /* width: 36px;\n    height: 36px; */\n    /* width: 32px;\n    height: 32px; */\n    width: 62px;\n    height: 60px;\n    margin: 0;\n    border-radius: 50%;\n    background-color: var(--primary);\n    color: var(--text-subtle);\n    font-size: 0.9rem;\n    font-weight: 600;\n    letter-spacing: 0.01rem;\n    text-align: center;\n    line-height: 36px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  /* Button */\n\n  .dropdown-trigger {\n    border: 0;\n    cursor: pointer;\n    display: inline-block;\n    padding: 0;\n    background-color: var(--trigger);\n    border-radius: 50%;\n  }\n\n  /* Dropdown */\n  .dropdown-menu {\n    margin-top: 12px;\n    right: 0;\n    white-space: normal;\n    background-color: var(--body-background);\n    border: 1px solid var(--border);\n    box-shadow: 0 6.4px 14.4px 0 var(--box-shadow-medium), 0 1.2px 3.6px 0 var(--box-shadow-light);\n    position: absolute;\n    top: 100%;\n    white-space: nowrap;\n    width: auto;\n    z-index: 1000;\n    padding: 1.25rem;\n\n    &:before {\n      content: '';\n      position: absolute;\n      bottom: 100%;\n      right: 10px;\n      margin-left: -8px;\n      border-width: 8px;\n      border-style: solid;\n      border-color: transparent;\n      border-bottom-color: var(--border);\n    }\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: 100%;\n      right: 10px;\n      margin-left: -7px;\n      border-width: 7px;\n      border-style: solid;\n      border-color: transparent;\n      border-bottom-color: var(--body-background);\n    }\n\n    .user-info {\n      align-items: flex-start;\n      display: flex;\n\n      figure,\n      .initials {\n        width: 42px;\n        height: 42px;\n        line-height: 48px;\n        margin-right: 1rem;\n        font-size: 1rem;\n        background-color: var(--trigger);\n      }\n\n      .user-content {\n        flex-basis: auto;\n        flex-grow: 1;\n        flex-shrink: 1;\n\n        h2 {\n          max-width: 200px;\n          word-break: break-word;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          font-size: 1.125rem;\n          font-weight: 600;\n          line-height: 1.125;\n          margin-bottom: 0;\n          margin-top: 0;\n        }\n\n        p {\n          margin: 0.2rem 0 0 0;\n          max-width: 200px;\n          font-weight: inherit;\n          display: inline-block;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          font-size: 0.875rem;\n        }\n      }\n    }\n    ul {\n      padding: 1rem 0;\n      font-size: 0.875rem;\n\n      li:not(:last-child) {\n        padding-bottom: 1rem;\n      }\n    }\n\n    .border-top {\n      border-top: 1px solid var(--border);\n      padding-top: 1rem;\n\n      button {\n        padding: 0;\n        margin: 0;\n        border: 0;\n        font-size: 0.875rem;\n        word-wrap: break-word;\n        color: var(--primary-base);\n        cursor: pointer;\n        text-decoration: none;\n      }\n    }\n  }\n\n  &.mobile {\n    .dropdown-menu {\n      top: auto;\n      bottom: 100%;\n      left: 0;\n      right: auto;\n      margin-top: 0;\n      margin-bottom: 12px;\n\n      &:before {\n        bottom: auto;\n        top: 100%;\n        right: auto;\n        left: 13px;\n        transform: rotate(180deg);\n      }\n      &:after {\n        bottom: auto;\n        top: 100%;\n        right: auto;\n        left: 17px;\n        transform: rotate(180deg);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @next/next/no-img-element */ 








var AvatarMenu = function(param) {
    var _mobile = param.mobile, mobile = _mobile === void 0 ? false : _mobile;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,msal_react_esm/* useMsal */.Fp)(), accounts = ref4.accounts, instance = ref4.instance;
    var ref5 = (0,react.useState)(false), open = ref5[0], setOpen = ref5[1];
    var locale = (0,router.useRouter)().locale;
    var dictionary = i18n/* default */.Z[locale || "en-US"].dictionary;
    var ref6 = (0,react.useRef)(null);
    (0,useClickAway/* default */.Z)(ref6, function() {
        setOpen(false);
    });
    var account = accounts[0];
    if (!account) {
        return null;
    }
    var name = "".concat(((ref = account.idTokenClaims) === null || ref === void 0 ? void 0 : ref.given_name) || "", " ").concat(((ref1 = account.idTokenClaims) === null || ref1 === void 0 ? void 0 : ref1.family_name) || "").trim() || account.name || ((ref2 = account.idTokenClaims) === null || ref2 === void 0 ? void 0 : ref2.name) || ((ref3 = account.idTokenClaims) === null || ref3 === void 0 ? void 0 : ref3.display_name) || account.username;
    var initials = name.split(" ").map(function(n) {
        return n[0];
    }).join("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAvatarMenu, {
        ref: ref6,
        className: mobile ? "mobile" : "desktop",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return setOpen(!open);
                },
                className: "dropdown-trigger",
                "aria-controls": "user-menu",
                "aria-expanded": "false",
                "aria-label": "Your account",
                children: initials ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "initials",
                    children: initials
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                    className: "avatar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        "data-profile-property": "avatarUrl",
                        src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSI+PGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNGNEY1RjYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMTE4NjUgMjYuNzE2MkM2LjE0MzYgMjIuMTY5NyAxMC43MDE2IDE5IDE2IDE5QzIxLjI5ODMgMTkgMjUuODU2NCAyMi4xNjk3IDI3Ljg4MTMgMjYuNzE2MkMyNC45NTMxIDI5Ljk2MDggMjAuNzE0NyAzMiAxNiAzMkMxMS4yODUzIDMyIDcuMDQ2ODkgMjkuOTYwOCA0LjExODY1IDI2LjcxNjJaTTIzIDEwQzIzIDEzLjg2NiAxOS44NjYgMTcgMTYgMTdDMTIuMTM0IDE3IDguOTk5OTkgMTMuODY2IDguOTk5OTkgMTBDOC45OTk5OSA2LjEzNDAxIDEyLjEzNCAzIDE2IDNDMTkuODY2IDMgMjMgNi4xMzQwMSAyMyAxMFoiIGZpbGw9IiNCOEI5QkEiLz48L3N2Zz4="
                    })
                })
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dropdown-menu",
                role: "menu",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "user-info",
                        children: [
                            initials ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "initials",
                                children: initials
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                className: "avatar",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "",
                                    "data-profile-property": "avatarUrl",
                                    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSI+PGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiNGNEY1RjYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMTE4NjUgMjYuNzE2MkM2LjE0MzYgMjIuMTY5NyAxMC43MDE2IDE5IDE2IDE5QzIxLjI5ODMgMTkgMjUuODU2NCAyMi4xNjk3IDI3Ljg4MTMgMjYuNzE2MkMyNC45NTMxIDI5Ljk2MDggMjAuNzE0NyAzMiAxNiAzMkMxMS4yODUzIDMyIDcuMDQ2ODkgMjkuOTYwOCA0LjExODY1IDI2LjcxNjJaTTIzIDEwQzIzIDEzLjg2NiAxOS44NjYgMTcgMTYgMTdDMTIuMTM0IDE3IDguOTk5OTkgMTMuODY2IDguOTk5OTkgMTBDOC45OTk5OSA2LjEzNDAxIDEyLjEzNCAzIDE2IDNDMTkuODY2IDMgMjMgNi4xMzQwMSAyMyAxMFoiIGZpbGw9IiNCOEI5QkEiLz48L3N2Zz4="
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "user-content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            id: "displayName",
                                            "data-profile-property": "displayName",
                                            children: name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "data-profile-property": "upn",
                                            children: account.username
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/account",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "data-profile-property": "profileUrl",
                                    children: dictionary.profile
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-top",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "logout-btn",
                            onClick: function() {
                                instance.logoutRedirect();
                                return js_cookie/* default.remove */.Z.remove(constants/* ACCESSTOKEN_COOKIE_NAME */.$c);
                            },
                            children: dictionary.logout
                        })
                    })
                ]
            })
        ]
    });
};
var StyledAvatarMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84ba4bcc-0"
})(_templateObject());
/* harmony default export */ var avatar_menu = (AvatarMenu);

// EXTERNAL MODULE: ./context/global-context.ts
var global_context = __webpack_require__(72265);
// EXTERNAL MODULE: ./hooks/useWindowEvent.ts
var useWindowEvent = __webpack_require__(76868);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./components/icon.tsx
var icon = __webpack_require__(14212);
;// CONCATENATED MODULE: ./components/library/dropdown-menu-m.tsx

function dropdown_menu_m_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 50;\n  display: flex;\n  height: 100%;\n\n  ",
        "\n"
    ]);
    dropdown_menu_m_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 0.5rem;\n  font-size: 1rem;\n  outline: none;\n  background: transparent;\n  cursor: pointer;\n\n  .dropdown-text {\n    padding-right: 0.25rem;\n    font-family: 'Alliance No.2';\n    font-size: 22px;\n    line-height: 26.06px;\n  }\n\n  &:hover {\n    .dropdown-text {\n      position: relative;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  color: var(--new-text-regular);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 10;\n  background-color: var(--new-dropdown-input-background);\n  border: 1px solid var(--new-border);\n  box-shadow: 0px 20px 7.5px 0px rgba(0, 0, 0, 0.1);\n  width: 220px;\n  top: 3.3rem;\n\n  div:nth-child(even) {\n    background-color: #def5fe;\n  }\n\n  ul {\n    display: contents !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  color: var(--new-text-regular);\n  font-size: var(--fontsize-base);\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var LanguageTypes;
(function(LanguageTypes) {
    LanguageTypes["da"] = "da-dk";
    LanguageTypes["de"] = "de-de";
    LanguageTypes["en-us"] = "en-us";
})(LanguageTypes || (LanguageTypes = {}));
var DropdownMenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-197d6b64-0"
})(dropdown_menu_m_templateObject(), function(props) {
    return props.show && "\n      background-color: var(--new-dropdown-input-background);\n  ";
});
var DropdownButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-197d6b64-1"
})(_templateObject1(), function(props) {
    return props.show ? "\n      .dropdown-text {\n        position: relative;\n        background-color: var(--new-dropdown-input-background);\n      }\n\n      .dropdown-wrapper {\n        background-color: var(--new-dropdown-input-background);\n      }\n        " : "&:hover {\n          .dropdown-text {\n            position: relative;\n            &:after {\n              content: '';\n              display: block;\n              position: absolute;\n              border-bottom: 2px solid var(--text);\n              left: 0;\n              right: 0;\n              bottom: -0.125rem;\n            }\n          }\n  }";
});
var DropdownButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-197d6b64-2"
})(_templateObject2());
var Dropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-197d6b64-3"
})(_templateObject3());
var DropdownItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-197d6b64-4"
})(_templateObject4());
var DropdownLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-197d6b64-5"
})(_templateObject5());
var DropdownMenu = function(param) {
    var text = param.text, menu = param.menu, prefix = param.prefix;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var keys = (0,react.useMemo)(function() {
        return menu.map(function() {
            return (0,v4/* default */.Z)();
        });
    }, [
        menu
    ]);
    var ref1 = (0,react.useRef)(null);
    var handleKeyDown = function(e) {
        if (e.keyCode === 27) {
            setShow(false);
        }
    };
    (0,useClickAway/* default */.Z)(ref1, function() {
        setShow(false);
    });
    (0,useWindowEvent/* default */.Z)("keydown", handleKeyDown);
    var checkPrefix = function() {
        if (prefix) {
            return "".concat(prefix).concat(LanguageTypes[locale.toLowerCase()]);
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuWrapper, {
        ref: ref1,
        show: show,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownButton, {
                show: show,
                onClick: function(e) {
                    e.stopPropagation();
                    show ? setShow(false) : setShow(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownButtonText, {
                        className: "dropdown-text",
                        children: text
                    }),
                    show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        name: "chevron-up-light"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        name: "chevron-down-light"
                    })
                ]
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    "aria-labelledby": "dropdownDefaultButton",
                    children: menu === null || menu === void 0 ? void 0 : menu.map(function(link, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                                href: "".concat(link.href),
                                children: link.name
                            })
                        }, keys[index]);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var dropdown_menu_m = (DropdownMenu);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./components/tailwind-m/search.tsx







var Search = function() {
    var ref = (0,router.useRouter)(), locale = ref.locale, push = ref.push;
    var dictionary = i18n/* default */.Z[locale || "en-US"].dictionary;
    var ref1 = (0,index_esm/* useForm */.cI)(), register = ref1.register, handleSubmit = ref1.handleSubmit;
    var onSubmit = function(data) {
        push({
            pathname: "/new-search",
            query: {
                query: data.query
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("query")), {
                        className: "shadow-none focus:shadow-none bg-textInputBackground h-8 placeholder-textRegular text-textRegular text-sm font-normal pl-8 pr-3 w-newSearch border-border border-2 focus:border-inputAccessability hover:border-inputAccessability",
                        placeholder: dictionary.searchPlaceholder,
                        autoComplete: "off"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        className: "h-4 w-auto absolute left-5 top-1/2 transform -translate-x-1/2 -translate-y-1/2",
                        // width="20"
                        // height="18"
                        viewBox: "0 0 21 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M17.2386 17.7918L12.616 13.0882C13.5171 11.8867 14.0178 10.4849 14.0178 8.88291C14.0178 4.97796 10.9138 1.87402 7.00889 1.87402C3.10394 1.87402 0 4.97796 0 8.88291C0 12.7879 3.10394 15.8918 7.00889 15.8918C8.61092 15.8918 10.0127 15.3912 11.2142 14.49L15.8368 19.1936L17.2386 17.7918ZM2.00254 8.88291C2.00254 6.07936 4.20534 3.87656 7.00889 3.87656C9.81245 3.87656 12.0152 6.07936 12.0152 8.88291C12.0152 11.6865 9.81245 13.8893 7.00889 13.8893C4.20534 13.8893 2.00254 11.6865 2.00254 8.88291Z",
                            className: "fill-textRegular"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var search = (Search);

;// CONCATENATED MODULE: ./components/library/header.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  height: 54px;\n  border-bottom: 1px solid var(--border);\n\n  .logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .nav-bar-logo {\n      display: flex;\n      justify-content: center;\n    }\n\n    svg {\n      height: 19px;\n      width: auto;\n\n      &.light {\n        fill: #052975;\n      }\n\n      &.dark,\n      &.high-contrast {\n        fill: #ffffff;\n      }\n    }\n  }\n\n  nav.nav-bar {\n    display: none;\n\n    ",
        " {\n      display: flex;\n      height: 100%;\n    }\n\n    .nav-bar-ul {\n      display: flex;\n      gap: 1rem;\n\n      .nav-bar-ul-li {\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n\n        .nav-bar-ul-li-a {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          align-self: stretch;\n          flex-shrink: 0;\n          flex-grow: 0;\n          min-width: 54px;\n          padding: 0 0.5rem;\n          background-color: transparent;\n          color: var(--text);\n          border: none;\n          text-decoration: none !important;\n          white-space: nowrap;\n          font-size: var(--fontsize-base);\n          line-height: normal;\n          cursor: pointer;\n          outline-offset: -0.125rem !important;\n\n          span {\n            position: relative;\n            display: flex;\n            align-items: center;\n          }\n\n          &.is-active > span:after,\n          &:hover > span:after {\n            content: '';\n            display: block;\n            position: absolute;\n            border-bottom: 2px solid var(--text);\n            left: 0;\n            right: 0;\n            bottom: -0.125rem;\n            /* bottom: -0.3rem; */\n          }\n\n          &.is-active,\n          &:active,\n          &:visited {\n            color: var(--text);\n            /* font-weight: bold; */\n          }\n        }\n      }\n    }\n  }\n\n  .desktop-right {\n    justify-content: center;\n    align-items: center;\n    display: none;\n    gap: 0.5rem;\n\n    ",
        " {\n      display: flex;\n    }\n  }\n\n  .line {\n    display: inline-block;\n    height: 1.7rem;\n    border-left: 2.5px solid var(--text-subtle);\n    margin-left: 1.5rem;\n    margin-right: 1rem;\n  }\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












// update needed
// import DropdownMenu from './dropdown-menu';

// replace later

var Header = function() {
    var instance = (0,msal_react_esm/* useMsal */.Fp)().instance;
    var theme = (0,react.useContext)(global_context/* GlobalContext */.k).theme;
    var ref = (0,router.useRouter)(), locale = ref.locale, asPath = ref.asPath;
    var ref1 = i18n/* default */.Z[locale || "en-US"], dictionary = ref1.dictionary, toplinks = ref1.toplinks, quickLinks = ref1.quickLinks, logolink = ref1.logolink, solutions = ref1.solutions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
        role: "banner",
        itemScope: true,
        itemType: "http://schema.org/Organization",
        theme: theme,
        id: "header",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex outer-padding justify-between w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: logolink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                itemProp: "url",
                                "aria-label": "Continia Learn",
                                className: "logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "nav-bar-logo",
                                    role: "presentation",
                                    "aria-hidden": "true",
                                    itemProp: "logo",
                                    itemScope: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: theme,
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "65.08 74.83 685.4 100.83",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M236.18,112.68c-17.37,0-19.06,10.45-19.06,24.57s1.7,24.85,19.06,24.85h28.95v12.71h-33.04c-25.42,0-32.06-14.97-32.06-37.56s6.63-37.28,32.06-37.28h31.34v12.71h-27.25Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M356.67,137.25c0,29.94-12.99,38.41-39.82,38.41s-39.82-8.47-39.82-38.41,12.99-38.12,39.82-38.12,39.82,8.47,39.82,38.12Zm-39.82,25.7c16.95,0,22.74-7.35,22.74-25.7s-5.79-25.42-22.74-25.42-22.73,7.06-22.73,25.42,5.79,25.7,22.73,25.7Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M372.39,112.68c0-8.47,4.24-12.71,12.71-12.71h26.26c16.95,0,29.09,5.79,29.09,25.56v49.28h-16.52v-44.9c0-11.3-4.37-17.22-15.67-17.22h-15.11c-2.83,0-4.24,1.41-4.24,4.23v57.9h-16.52v-62.13Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M494.02,174.81c-16.95,0-27.54-6.07-27.54-24.43v-37.7h-10.31v-12.71h10.31v-24.01h16.52v24.01h21.32v12.71h-21.32v34.31c0,11.3,5.93,15.11,17.23,15.11h4.09v12.71h-10.31Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M522.33,90.09h0c0-8.42,6.83-15.25,15.25-15.25h1.27s0,15.25,0,15.25h-16.52Zm0,9.88h16.52v74.84h-16.52V99.97Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M558.92,112.68c0-8.47,4.24-12.71,12.71-12.71h26.27c16.95,0,29.09,5.79,29.09,25.56v49.28h-16.52v-44.9c0-11.3-4.37-17.22-15.67-17.22h-15.11c-2.83,0-4.24,1.41-4.24,4.23v57.9h-16.52v-62.13Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M647.09,90.09v-15.25h16.52c0,8.42-6.83,15.25-15.25,15.25h-1.27Zm0,9.88h16.52v74.84h-16.52V99.97Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M729.43,99.97c14.12,0,21.04,9.32,21.04,22.03v40.1c0,8.47-4.24,12.71-12.71,12.71h-37.7c-12.71,0-18.64-7.77-18.64-23.3,0-14.12,5.93-23.3,18.64-23.3h33.89v-4.8c0-7.06-3.39-10.73-10.45-10.73h-36.57v-12.71h42.5Zm-23.02,40.95c-5.65,0-7.9,3.53-7.9,10.59s2.26,10.59,7.9,10.59h23.3c2.83,0,4.24-1.41,4.24-4.23v-16.95h-27.54Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M118.68,125.39v49.47h-53.59c0-27.32,22.15-49.47,49.47-49.47h4.12Z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: "st0",
                                                d: "M118.68,125.39v-49.47h53.59c0,27.32-22.15,49.47-49.47,49.47h-4.12Z"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "nav-bar",
                            role: "navigation",
                            "aria-label": "Global",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "nav-bar-ul",
                                children: toplinks.map(function(link, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "nav-bar-ul-li",
                                        children: [
                                            index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "line"
                                            }),
                                            index === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu_m, {
                                                text: link.name,
                                                menu: solutions
                                            }),
                                            index === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_menu_m, {
                                                text: link.name,
                                                menu: quickLinks,
                                                prefix: constants/* PATH_DOCS */.Au
                                            }),
                                            index !== 1 && index !== 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: link.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "".concat(asPath === link.href || asPath.startsWith("".concat(link.href, "/")) ? "is-active" : "", " nav-bar-ul-li-a"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "mr-2",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "18.102",
                                                                height: "15.533",
                                                                viewBox: "0 0 20.102 17.533",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                                    "data-name": "Group 3210",
                                                                    opacity: "0.998",
                                                                    transform: "translate(-390.852 -61.17)",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                                            "data-name": "Group 3199",
                                                                            transform: "translate(394.804 66.297)",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                className: "fill-textRegular stroke-textRegular",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round",
                                                                                strokeWidth: "2",
                                                                                d: "M12.219 5.1L6.178 0-.001 5.1v6.306h3.244V6h5.73v5.406h3.245z",
                                                                                "data-name": "Path 337"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            fill: "none",
                                                                            className: "stroke-textRegular",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round",
                                                                            strokeWidth: "2",
                                                                            d: "M392.26 69.391l8.77-7.221 8.515 7.221",
                                                                            "data-name": "Path 350"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            link.name
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }, link.href);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "desktop-right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(msal_react_esm/* AuthenticatedTemplate */.NY, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_menu, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(msal_react_esm/* UnauthenticatedTemplate */.ae, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "w-max-content text-textContinia py-1 px-2.5 text-base outline-none focus:outline-none bg-transparent hover:bg-buttonLinkHover",
                                onClick: function() {
                                    instance.loginRedirect(config/* loginRequest */.Qb).then(function(res) {
                                        console.log("@login success", res);
                                    }).catch(function(err) {
                                        console.log("@login error", err);
                                    });
                                },
                                children: dictionary.login
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-9b9bfc24-0"
})(header_templateObject(), styles/* mqFrom.mobile */.wO.mobile, styles/* mqFrom.mobile */.wO.mobile);
/* harmony default export */ var header = (Header);


/***/ }),

/***/ 76868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useWindowEvent = function(event, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener(event, callback);
        return function() {
            return window.removeEventListener(event, callback);
        };
    }, [
        event,
        callback
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowEvent);


/***/ })

}]);